// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "tr.choice td .form-group[data-v-49d45622] {\n  margin-bottom: 0px;\n}\ntr.choice td[data-v-49d45622]:nth-child(2) {\n  width: 350px;\n}\n.correct-choice[data-v-49d45622] {\n  max-width: 100px;\n  display: inline-block;\n}\n.img-url-wrapper[data-v-49d45622] {\n  background: #ccc;\n  border: 1px solid #e4eaec;\n}\n.img-url-wrapper img[data-v-49d45622] {\n  display: block;\n  margin: 0 auto;\n  max-height: 120px;\n}", ""]);
// Exports
module.exports = exports;
